/** Session/display roles after auth normalization */
export enum Role {
  /** Full admin portal access (legacy "Admin" users) */
  SUPER_ADMIN = "Super Admin",
  /** Limited admin — all modules except Roles & Record Set Management */
  ADMIN = "Admin",
  VERIFIER = "Verifier",
}

export const RoleText: Record<Role, string> = {
  [Role.SUPER_ADMIN]: "Super Admin",
  [Role.ADMIN]: "Admin",
  [Role.VERIFIER]: "Verifier",
};

export const RoleArray = Object.entries(RoleText).map(([key, value]) => ({
  id: key,
  value: key,
  label: value,
}));

export const ROLE_NOT_ASSIGNED_LABEL = "Not Assigned";
